<div class="popover-container" [ngClass]="productPopoverClass">
  <div class="product-info">
    <div class="img-container">
      <img
        class="product-thumbnail"
        *ngIf="
          (panAppState.online$ | async) === true &&
          !!productDetails?.imageThumbnail
        "
        [attr.data-cy]="'product-' + productDetails?.productNumber + '-image'"
        src="{{ productDetails?.imageThumbnail }}"
        (error)="
          productDetails.imageThumbnail = getAlternativeThumbnail(
            productDetails?.imageThumbnail
          )
        "
      />
      <ion-icon
        *ngIf="
          (panAppState.online$ | async) === false ||
          !productDetails?.imageThumbnail
        "
        data-cy="product-card-no-image-icon"
        class="no-image"
        name="restaurant"
      ></ion-icon>
    </div>
    <div class="text-container">
      <div
        class="top-drawer-container"
        *ngIf="hasCustomMessage && !isGuestUser"
      >
        <ion-icon
          class="popover-icon"
          name="{{ productDetails?.drawerMsg?.iconName }}"
        ></ion-icon>
        <span class="popover-message">
          <span [ngClass]="{ bold: customMessageIsWarning }">{{
            messageMainText | translate
          }}</span>
          {{ messageSecondaryText }}
        </span>
      </div>
      <div
        *ngIf="hasCustomMessage && !isGuestUser"
        class="product-name-container"
      >
        <div class="product-name">
          {{ productDetails?.summary?.productDescTxtl | sentenceCase: 'ALL' }}
        </div>
      </div>
    </div>
    <div
      *ngIf="!hasCustomMessage || isGuestUser"
      class="product-name-container"
    >
      <div class="product-name">
        {{ productDetails?.summary?.productDescTxtl | sentenceCase: 'ALL' }}
      </div>
    </div>
    <button
      *ngIf="isActionable"
      (click)="closeCardHandler(productDetails)"
      [disabled]="cardsNumber === 2"
    >
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
</div>
